import { Component, OnInit } from '@angular/core';
import { ErrorHandler } from '../../../shared/services/error-handler.service';

// services
import { EventsService } from '../../../booking/services/events.service';
import { LoginService } from '../../../shared/services/login.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NotificationsComponent } from '@shared/components/notifications/notifications.component';
import { SetPasswordComponent } from '@shared/components/set-password/set-password.component';
import { LanguageSelectorComponent } from '@shared/components/language-selector/language-selector.component';

@Component({
  selector: 'app-set-password-section',
  standalone: true,
  imports: [CommonModule, FormsModule, NotificationsComponent, SetPasswordComponent, LanguageSelectorComponent],
  templateUrl: './set-password-section.component.html',
  styleUrls: ['./set-password-section.component.scss'],
  providers: [EventsService, LoginService, ErrorHandler]
})
export class SetPasswordSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
